<template>
  <div id="app">
    <link href="https://fonts.googleapis.com/css?family=Nunito:300,700" rel="stylesheet">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  html, body {
    font-family: 'Nunito', sans-serif;
    color: #666;
    margin:0;
  }

  footer {
    margin-top: 20px;
    font-size: 12px;
    text-align: center;
    padding: 0 6%;
    color: #ccc;
  }

  a {
    text-decoration: none;
    color: #30A5F0;
  }

  footer img {
    display: block;
    margin: 15px auto;
    width: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue